let config = {
  SECURE_PROTOCOL: 'http',
  PROTOCOL: 'https',
  //URL: 'sportocotoday.com',
  //URL: '3.145.83.156',
  //URL: 'beta.admin.sportzag.com',
  URL: 'dev1admin.sportzag.com',
  APIHOST: 'dev1api.sportzag.com',
  //PORT: 6604,
  SALT: 'Sportoco',
  IMAGE_FOLDER: 'image',
  AUTOMATION_PORT: 8080,
  AUTOMATION_AGENT: `/job/${
    navigator.userAgent.indexOf('Win') != -1
      ? 'windows_test1automation'
      : navigator.userAgent.indexOf('Mac') != -1
      ? 'mac_test1automation'
      : ''
  }/buildWithParameters?token=sportoco`,
  HOST_COMMAND_URL: 'dev1command.sportzag.com',
  HOST_COMMAND_PORT: 80,
  GAME_APP_URL: 'dev1app.sportzag.com',
  GAME_APP_PORT: 80,
  MEDIA_BASE_URL: 'https://assets-dev1.sportzag.com/',
  /*
  HOST_COMMAND_URL: 'localhost',
  HOST_COMMAND_PORT: 1030,
  GAME_APP_URL: 'localhost',
  GAME_APP_PORT: 2000,
*/
  /*
  HOST_COMMAND_URL: '192.168.0.153',
  HOST_COMMAND_PORT: 1030,
  GAME_APP_URL: '192.168.0.153',
  GAME_APP_PORT: 2000,
*/
}

config.connectOptions = {
  hostname: config.APIHOST,
  //port: config.PORT,
  //path: '/socketcluster',
  autoReconnectOptions: {
    initialDelay: 6000,
    randomness: 10000,
    multiplier: 1.5,
    maxDelay: 60000,
  },
}


export default config


// WEBPACK FOOTER //
// src/Agent/config.js